/**
 * Horizontal stat bar used on Dashboard, Library, and Packs pages.
 * Each stat: { icon, label, value, onClick? }
 */
export function StatBar({ stats, testId = "stat-bar" }) {
  return (
    <div
      className="flex items-center gap-4 px-4 py-2 border border-[var(--pf-border)] bg-[var(--pf-surface)] mb-4 text-xs text-[var(--pf-text-secondary)]"
      data-testid={testId}
    >
      {stats.map((s, i) => {
        const Icon = s.icon;
        const Wrapper = s.onClick ? "button" : "span";
        return (
          <span key={s.label + i} className="flex items-center gap-1.5">
            {i > 0 && <span className="text-[var(--pf-border)] mr-3">|</span>}
            <Wrapper
              onClick={s.onClick}
              data-testid={s.testId}
              className={s.onClick ? "flex items-center gap-1.5 cursor-pointer hover:text-[var(--pf-accent)]" : "flex items-center gap-1.5"}
            >
              {Icon && <Icon className="w-3.5 h-3.5 text-[var(--pf-text-muted)]" />}
              <span className="font-bold text-[var(--pf-text)]">{s.value}</span>
              <span className="text-[var(--pf-text-secondary)]">{s.label}</span>
            </Wrapper>
          </span>
        );
      })}
    </div>
  );
}
